// @ts-check

import { useDialog } from '@/core/composables/useDialog'
import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'

/**
 * Everything in this store gets synced between mobile wrapper and the application.
 * We should not store any complex data here.
 */
export const useSharedStore = defineStore('shared', () => {
  const { closeDialog, dialog } = useDialog()

  const isDialogOpen = ref(!!dialog.value)

  watchEffect(() => {
    if (isDialogOpen.value) {
      return
    }

    closeDialog()
  })

  const $reset = () => {
    isDialogOpen.value = false
  }

  return { isDialogOpen, $reset }
})
